import { Component, ViewEncapsulation, OnInit, ViewChild,EventEmitter,Input,Output,TemplateRef,AfterContentInit,QueryList,ContentChildren,
  Compiler, ComponentRef, Injector, NgModule, NgModuleRef, ViewContainerRef} from '@angular/core';
import { BreadcrumbService } from 'src/app/services/sm-Services/breadcrumb.service';
// import { BreadcrumbService } from 'src/app/SmartReporter/sm-Services/breadcrumb.service';
  declare var $ : any;

@Component({
  selector: 'app-dynamic-component',
  templateUrl: './dynamic-component.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,

})
export class DynamicComponentComponent implements OnInit {
  @Input() componentContext;
  @Output() componentSelection = new EventEmitter<any>();
  componentData:any;
  constructor(private breadcumbservice:BreadcrumbService) { }
  @ViewChild('modalBody', {read: ViewContainerRef}) modalBody: ViewContainerRef;
  loading = false;
  user:any;
  step_form:any;
  ngOnInit() {
console.log(this.componentContext);
  }
  ngAfterViewInit(){
   $('.custom-sidenav-item .sidenav-link').parent().removeClass('link-active');
   $('[data-link-id="'+this.componentContext.id+'"]').parent().addClass('link-active');
  }
  public componentSelectionEmitter(componentData: any) {
    console.log(componentData)
    this.componentData = componentData;
    if(componentData.type=='sm-permission')
    {
      this.breadcumbservice.categorytab=true;
    }
      this.breadcumbservice.comp=true;
      this.breadcumbservice.add(componentData.name,this.breadcumbservice.length,componentData.name,true);
    this.componentSelection.emit(this.componentData);
    // console.log("test")
    // if(componentData.type=='sm-permission')
    // {
    //   this.breadcumbservice.categorytab=false;
    // }
  }
  private cmpRef: ComponentRef<any>;
  // Cleanup properly. You can add more cleanup-related stuff here.
  ngOnDestroy() {
    if(this.cmpRef) {
      this.cmpRef.destroy();
    }
  }
}
